// import React from "react";
// import DocumentationLibraryBanner from "../Components/DocumentationLibraryBanner";
// import DocumentationLibraryInfo from "../Components/DocumentationLibraryInfo";

// const DocumentationLibrary = () => {
//   return (
//     <>
//       <DocumentationLibraryBanner />
//       <DocumentationLibraryInfo />
//     </>
//   );
// };

// export default DocumentationLibrary;
import React from "react";
import { getSEOData } from "../../../global/utils/constants/seoConfig";
import SEO from "../../../global/components/SEO/SEO";
import DocumentationLibraryBanner from "../Components/DocumentationLibraryBanner";
import DocumentationLibraryInfo from "../Components/DocumentationLibraryInfo";

const DocumentationLibrary = () => {
  const seoData = getSEOData("/documentation-library");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <DocumentationLibraryBanner />
      <DocumentationLibraryInfo />
    </>
  );
};

export default DocumentationLibrary;